import React from 'react';
import { Box, Typography, Container, Button, Paper } from '@mui/material';
import { CheckCircleOutline as CheckCircleIcon, HomeOutlined as HomeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const ApplicationSuccess = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <Paper sx={{ p: 4 }}>
        <CheckCircleIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          Application Submitted Successfully!
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Thank you for submitting your rental application. We have received your information and will review it shortly.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          You will receive a confirmation email with your application reference number shortly.
        </Typography>
        <Button
          variant="contained"
          startIcon={<HomeIcon />}
          onClick={() => navigate('/')}
        >
          Return to Home
        </Button>
      </Paper>
    </Container>
  );
};

export default ApplicationSuccess;






